import BreadCrump from "../tools/breadcrump"
import { getCookies } from "cookies-next";
import { useEffect, useState } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import { config } from "../../data/config";
import { useParams, useNavigate } from "react-router-dom";
import HeaderOfPage from "../tools/headerOfPage";

const statusLabels: Record<string, string> = {
    new: 'جدید',
    pending: 'در حال بررسی',
    success: 'تایید شده',
    reject: 'رد شده',
};

export default function CooperationDetail() {
    const { Id } = useParams();
    const navigate = useNavigate();
    const cookie = getCookies();
    const [item, setItem] = useState<any>(null);
    const [status, setStatus] = useState('new');
    const [saving, setSaving] = useState(false);

    const breadcrump = [
        { name: 'Dashboard', url: '/dashboard' },
        { name: 'درخواست همکاری', url: '/dashboard/Cooperation/list' },
        { name: 'جزئیات', url: null },
    ];

    const getData = async () => {
        try {
            const res = await axios({
                method: 'get',
                url: config.url + '/v1/dashboard/cooperation/' + Id,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                },
            });
            setItem(res.data.message);
            setStatus(res.data.message?.status || 'new');
        } catch (error) {
            Swal.fire('خطا', 'درخواست یافت نشد', 'error');
            navigate('/dashboard/Cooperation/list');
        }
    };

    const saveStatus = async () => {
        setSaving(true);
        try {
            await axios({
                method: 'put',
                url: config.url + '/v1/dashboard/cooperation/' + Id,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                },
                data: { status },
            });
            Swal.fire('ذخیره شد', 'وضعیت به‌روزرسانی شد', 'success');
            getData();
        } catch (error) {
            Swal.fire('خطا', 'خطا در ذخیره وضعیت', 'error');
        } finally {
            setSaving(false);
        }
    };

    useEffect(() => {
        getData();
    }, [Id]);

    if (!item) {
        return (
            <div className="text-left directions bg-white p-3 m-4 mb-5">
                <p className="text-gray-500">در حال بارگذاری...</p>
            </div>
        );
    }

    const category =
        item.activityCategory === 'دیگر' && item.activityCategoryOther
            ? `${item.activityCategory} (${item.activityCategoryOther})`
            : item.activityCategory;

    const activityType =
        item.activityType === 'نوع فعالیت دیگر' && item.activityTypeOther
            ? `${item.activityType} (${item.activityTypeOther})`
            : item.activityType;

    return (
        <div className="text-left directions bg-white p-4 sm:p-6 m-4 rounded-xl shadow-sm border border-gray-100 min-h-[calc(100vh-2rem)] mb-5">
            <BreadCrump data={breadcrump}></BreadCrump>
            <HeaderOfPage name="جزئیات درخواست همکاری"></HeaderOfPage>

            <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6" dir="rtl">
                <div className="space-y-4">
                    <Field label="نام و نام خانوادگی" value={item.fullName} />
                    <Field label="نام مجموعه/شرکت/فروشگاه" value={item.companyName} />
                    <Field label="شماره تلفن" value={item.phone} ltr />
                    <Field label="شماره محل کار" value={item.workPhone} ltr />
                    <Field label="دسته فعالیت و حوزه کاری" value={category} />
                    <Field label="نوع فعالیت" value={activityType} />
                    <div>
                        <label className="block text-sm text-gray-500 mb-1">توضیحات</label>
                        <div className="text-sm font-medium text-gray-900 bg-gray-50 rounded-lg px-3 py-2 border border-gray-100 whitespace-pre-wrap min-h-[80px]">
                            {item.description || '—'}
                        </div>
                    </div>
                    <Field
                        label="تاریخ ثبت"
                        value={new Date(item.createdAt).toLocaleString('fa-IR')}
                    />
                    <div>
                        <label className="block text-sm text-gray-500 mb-1">وضعیت</label>
                        <div className="flex gap-2 items-center">
                            <select
                                value={status}
                                onChange={(e) => setStatus(e.target.value)}
                                className="border border-gray-200 rounded-lg px-3 py-2 text-sm"
                            >
                                {Object.entries(statusLabels).map(([key, label]) => (
                                    <option key={key} value={key}>{label}</option>
                                ))}
                            </select>
                            <button
                                type="button"
                                onClick={saveStatus}
                                disabled={saving}
                                className="bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-lg text-sm disabled:opacity-60"
                            >
                                {saving ? '...' : 'ذخیره وضعیت'}
                            </button>
                        </div>
                    </div>
                </div>

                <div>
                    <label className="block text-sm text-gray-500 mb-2">عکس کارت ویزیت یا جواز کسب</label>
                    {item.businessCardImage ? (
                        <a
                            href={config.url + item.businessCardImage}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                src={config.url + item.businessCardImage}
                                alt="کارت ویزیت / جواز کسب"
                                className="max-w-full max-h-96 rounded-lg border border-gray-200 object-contain"
                            />
                        </a>
                    ) : (
                        <p className="text-sm text-gray-400">تصویری آپلود نشده است</p>
                    )}
                </div>
            </div>

            <div className="mt-6">
                <a
                    href="/dashboard/Cooperation/list"
                    className="text-sm text-orange-600 hover:text-orange-700"
                >
                    ← بازگشت به لیست
                </a>
            </div>
        </div>
    );
}

function Field({ label, value, ltr }: { label: string; value: string; ltr?: boolean }) {
    return (
        <div>
            <label className="block text-sm text-gray-500 mb-1">{label}</label>
            <div
                className="text-sm font-medium text-gray-900 bg-gray-50 rounded-lg px-3 py-2 border border-gray-100"
                dir={ltr ? 'ltr' : 'rtl'}
            >
                {value || '—'}
            </div>
        </div>
    );
}
